/**
 * @classdesc Italian Language Pack
 * @desc This class will used to translate tokens into the Italian language.
 * @namespace Languages.Italian
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Italian
 */
export const dictionary = {
	'years'   : 'Anni',
	'months'  : 'Mesi',
	'days'    : 'Giorni',
	'hours'   : 'Ore',
	'minutes' : 'Minuti',
	'seconds' : 'Secondi'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Italian
 */
export const aliases = ['da', 'da-dk', 'danish'];
